import { useImmer } from "use-immer";
import { useRef, useState, useEffect, useContext, useMemo } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useDebounce } from "use-debounce";
import { usePermission, useStatusSelect } from "../../../shared";
import { AppContext } from "../../../store";
import { useFinishedProductsWithoutPLUQueries } from "./useFinishedProductsWithoutPLUQueries";
import { useCategoryQueries } from "../../MasterData/hooks/useCategoryQueries";

export const useFinishedProductsWithoutPLU = () => {
  const moduleName = "finishedProductsWithoutPlu";
  const {
    tableData,
    setSorting,
    setPagination,
    setSearchState,
    setTableState,
    clearAllFilters,
  } = useContext(AppContext);

  // const { search } = tableData[moduleName];
  const [state, setState] = useImmer({
    isLoading: true,
    dataList: { categoryfilter: [] },
    filters: {},
  });

  const { listQuery: categoryListQuery } = useCategoryQueries({
    categorylist: true,
  });

  const CategoryOptions = categoryListQuery?.data?.map((v) => {
    return { id: v.id, name: v.name };
  });

  const [debouncedText] = useDebounce(state?.search, 1000);

  const { listQuery } = useFinishedProductsWithoutPLUQueries({
    selectedCategory:
      tableData?.finishedProductsWithoutPlu?.data?.categoryfilter,
    selectedType: state.selectedType,
    selectedStatus: tableData?.finishedProductsWithoutPlu?.data?.selectedStatus,
    selectedSubCategory:
      tableData?.finishedProductsWithoutPlu?.data?.subcategoryfilter,
    debouncedText,
  });

  useEffect(() => {
    // getUnits();
    if (listQuery?.data) {
      setState((draft) => {
        draft.dataList = listQuery?.data || [];
        draft.isLoading = false;
      });
    }
  }, [listQuery?.data]);

  const categoryValuesHandler = (event, option) => {
    const item = option?.map((item) => {
      return { ...item };
    });
    setTableState({
      tableName: moduleName,
      key: "categoryfilter",
      value: item,
    });
  };

  const onChangeStatusHandler = (value) => {
    setTableState({
      tableName: moduleName,
      key: "selectedStatus",
      value: value,
    });
  };

  const selectStatus = useStatusSelect({ onChangeStatusHandler });

  const onClearFilter = () => {
    clearAllFilters({ tableName: moduleName });
  };

  // const selectedType = tableData?.finishedProductsWithoutPlu?.data?.selectedType;

  const selectedCategoryIds = useMemo(() => {
    return (
      tableData?.finishedProductsWithoutPlu?.data?.categoryfilter?.map(
        (c) => c.id,
      ) || []
    );
  }, [tableData?.finishedProductsWithoutPlu?.data?.categoryfilter]);

  const SubCategoryOptions = useMemo(() => {
    if (!selectedCategoryIds.length || !categoryListQuery?.data) return [];

    return categoryListQuery.data
      .filter((cat) => selectedCategoryIds.includes(cat.id))
      .flatMap((cat) => cat.subData || [])
      .map((sub) => ({
        id: sub.id,
        name: sub.name,
      }));
  }, [selectedCategoryIds, categoryListQuery?.data]);

  const subCategoryValuesHandler = (event, option) => {
    const item = option?.map((item) => {
      return { ...item };
    });
    setTableState({
      tableName: moduleName,
      key: "subcategoryfilter",
      value: item,
    });
  };

  useEffect(() => {
    setTableState({
      tableName: moduleName,
      key: "subcategoryfilter",
      value: [],
    });
  }, [selectedCategoryIds]);

  const categoryFilter =
    tableData?.finishedProductsWithoutPlu?.data?.categoryfilter;
  const selectedStatus =
    tableData?.finishedProductsWithoutPlu?.data?.selectedStatus;

  const disableclearButton = !(
    (Array.isArray(categoryFilter) && categoryFilter.length > 0) ||
    (selectedStatus !== null && selectedStatus !== "")
  );

  return {
    state,
    listQuery,
    categoryValuesHandler,
    CategoryOptions,
    tableData,
    selectStatus,
    onChangeStatusHandler,
    onClearFilter,
    disableclearButton,
    SubCategoryOptions,
    subCategoryValuesHandler,
  };
};
